<ng-select
  [items]="customers"
  [clearable]="true"
  placeholder="Search by email or phone number"
  (change)="onCustomerSelected($event)"
  (search)="onSearch($event.term)"
  (clear)="onClear()"
  [loading]="loading"
  [bindLabel]="searchParam"
  bindValue="id"
  [notFoundText]="displayNotFoundText"
  i18n-notFoundText
  autocomplete="off"
  [inputAttrs]="{
    autocomplete: 'off',
    'aria-label': 'Search customer'
  }"
>
  <ng-template ng-option-tmp let-item="item">
    <ng-container *ngIf="item.id !== 'load-more'">
      <div class="columns">
        <div
          class="column has-white-space-normal has-text-word-break"
          [ngClass]="{ 'pb-0': this.isDeviceMobile$ | async }"
        >
          {{ item?.firstName ? item?.firstName + ' ' : '' }}{{ item?.lastName || '-' }}
        </div>
        <div
          class="column has-white-space-normal has-text-word-break"
          [ngClass]="{ 'pb-0': this.isDeviceMobile$ | async }"
          title="{{ item.emailAddress }}"
        >
          <span class="has-text-grey" i18n>Email:</span>
          {{ item.emailAddress || '-' }}
        </div>
        <div class="column">
          <span class="has-text-grey" i18n>Phone:</span> {{ item.phoneNumber || '-' }}
        </div>
      </div>
    </ng-container>

    <div *ngIf="item.id === 'load-more'" (click)="$event.stopPropagation()">
      <a *ngIf="!loading" (click)="onLoadMore()">
        <span class="ml-2" i18n>Load more</span>
      </a>
      <span *ngIf="loading" class="ml-2" i18n>Loading...</span>
    </div>
  </ng-template>
</ng-select>
